import { ReactElement } from "react"
import styled from "@emotion/styled"
import { Grid, Hidden } from "@mui/material"
/* eslint-disable no-unused-vars */
import {
  BsFillEnvelopeFill,
  BsFillTelephoneFill,
  BsWhatsapp,
} from "react-icons/bs"

import { SpecialTitle } from "../App"
import { base } from "../lib/theme"
import { useTranslation } from "../TranslationProvider"
import ContactForm from "./ContactForm"
import DownloadSection from "./DownloadSection"

export default function Footer(): ReactElement {
  const { t } = useTranslation()

  return (
    <FooterWrapper container>
      <Hidden only={["md", "lg", "xl"]}>
        <StyledHr style={{ color: "var(--white)" }} />
      </Hidden>

      <LeftColumn item xs={12} md={6}>
        <FooterText>
          <SpecialTitle>{t("footer.title")}</SpecialTitle>

          <p>{t("footer.text")}</p>
        </FooterText>

        <ContactForm />
      </LeftColumn>

      <RightColumn item xs={12} md={6}>
        <InfoWrapper>
          <SocialMediaWrapper container>
            <Grid item xs={12} sm={6} md={12} lg={6}>
              <a
                href="https://showbird.com/nl/search?artist=2215&amp;ref=button"
                aria-label={t("accessibility.showbirdBooking")}
                target="_new"
                style={{ zoom: 1.1 }}>
                <Image src="https://showbird.com/images/embed_images/review5stars_black1.png" />

                <p>
                  <b>{t("footer.showbird")}</b>
                </p>
              </a>
            </Grid>

            <Hidden only={["sm", "lg"]}>
              <StyledHr />
            </Hidden>

            <Grid item xs={12} sm={6} md={12} lg={6}>
              <ContactWrapper>
                <LinkWrapper
                  href="https://wa.me/message/WTY3OGWQ6WHZJ1"
                  target="_new"
                  aria-label={t("accessibility.whatsappContact")}>
                  <BsWhatsapp size={25} color={base} />

                  <LinkText>{t("footer.whatsapp")}</LinkText>
                </LinkWrapper>
              </ContactWrapper>

              <ContactWrapper>
                <LinkWrapper
                  href="tel:+31641763563"
                  target="_new"
                  aria-label={t("accessibility.phoneNumber")}>
                  <BsFillTelephoneFill size={25} color={base} />

                  <LinkText>+31 (0)6 417 63 563</LinkText>
                </LinkWrapper>
              </ContactWrapper>

              <ContactWrapper>
                <LinkWrapper
                  href="mailto:info@stepthegap.com"
                  target="_new"
                  aria-label={t("accessibility.emailAddress")}>
                  <BsFillEnvelopeFill size={25} color={base} />

                  <LinkText>info@stepthegap.com</LinkText>
                </LinkWrapper>
              </ContactWrapper>
            </Grid>
          </SocialMediaWrapper>

          <StyledHr />

          <DownloadSection />

          <StyledHr />

          <AddressWrapper translate="no">
            <h3>
              <b>Step the Gap</b>
            </h3>

            <span>
              <b>Steven de Lange</b>
              <br />
              <b>Stephanie Wijngaard - de Lange</b>
            </span>

            <span>
              Jutfaseweg 243
              <br />
              3522HS Utrecht
            </span>

            <span>
              <b>KvK:</b> 62690523
              <br />
              <b>Btw:</b> NL002189580B82
              <br />
              <b>Bank:</b> NL51 BUNQ 2034 6771 61
            </span>
          </AddressWrapper>
        </InfoWrapper>
      </RightColumn>
    </FooterWrapper>
  )
}

const FooterWrapper = styled(Grid)`
  width: 100%;
  max-width: 150rem;
  min-height: 20rem;
  text-align: center;

  background: linear-gradient(
    160deg,
    rgba(0, 0, 0, 1) 54%,
    rgba(75, 46, 110, 1) 82%
  );

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 3rem 0 1rem;
  gap: 2rem;

  @media only screen and (min-width: 600px) {
    padding: 4rem 2rem 3rem;
  }

  @media only screen and (min-width: 900px) {
    gap: 0;
  }
`

const LeftColumn = styled(Grid)`
  padding: 0 1rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`

const FooterText = styled.div`
  user-select: none;
`

const RightColumn = styled(Grid)`
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const InfoWrapper = styled.div`
  padding: 0.3rem;
  width: 90%;
  min-height: 20rem;
  border-radius: 0.5rem;
  box-shadow: 0.1rem 0.1rem 0.3rem black;

  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-content: center;

  background-color: var(--white);
  color: black;
`

const AddressWrapper = styled.div`
  padding: 1rem 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;

  h3 {
    margin: 0;
  }
`

const ContactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const LinkWrapper = styled.a`
  display: flex;
  justify-content: space-around;
  align-items: center;
`

const LinkText = styled.h3`
  font-weight: bold;
  padding-left: 0.5rem;
  font-size: 1rem;
`

const Image = styled.img`
  margin-top: 1.2rem;
  width: 180px;
  border-radius: 0.3rem;
  box-shadow: 4px 4px 6px 1px rgba(0, 0, 0, 0.5);
`

const SocialMediaWrapper = styled(Grid)`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`

const StyledHr = styled.hr`
  width: 70%;
  color: var(--tertiary);
`
